<template>
    <div class="section-posts2 section-posts-feed">
        <div class="navigations">
            <div class="container-list-avatar">
                <div class="list-avatar hide-scrollbar">
                    <Tooltip 
                        v-for="page in pagesSelected" 
                        :text="page.name"
                        :key="page.id"
                    >
                        <Avatar 
                            
                            :urlPicture="page.avatar" 
                            :typeNetwork="page.network" 

                            :checked="pageSelected && page.id == pageSelected.id"
                            @click="()=> selectPage(page)"
                        />
                    </Tooltip>
                </div>
            </div>
          
            <MainNavigation v-on="$listeners" :tabSelected="tabSelected"/>
        </div>
        <div class="content">
            <ListPosts 
                v-if="pageSelected && Object.keys(groupedItems).length" 
                :groups="groupedItems" 
                @selectEvent="handleEventClick"
                @changeDate="changeDate"
            />
            <PostNotFound v-else />
            <div class="instagram-app">
                <div class="container-phone">
                    <div class="actions">
                        <div class="container-legend">
                            <div class="legend">
                                <div class="item" v-for="status in ['scheduled', 'draft', 'posted']">
                                    <div class="circle-status card-status-background-primary-color" :class="status"></div>
                                    <p class="card-status-color" :class="status">{{$t(`dash.post.${status}`)}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="btns">
                            <div class="btn" @click="refreshInstagramData">
                                <i class="fa-solid fa-rotate"></i>
                            </div>
                            <div class="btn">
                                <i class="fa-solid fa-moon"></i>
                            </div>
                            <div class="btn">
                                <i class="fa-solid fa-download"></i>
                            </div>
                        </div>
                    </div>
                   
                    <Phone>
                        <InstagramInterface 
                            :plannedItems="plannedItems" 
                            :postedItems="postedItems" 
                            :pinnedItems="pinnedItems" 
                            :statsProfile="statsProfile"
                            :page="pageSelected"
                            :loadingCard="this.configFetchItemPosted.isLoading || !this.configFetchItemPosted.isEnd"
                            @changeDate="changeDate"
                            @loadMorePostedItems="fetchItemPosted"
                            
                        />
                    </Phone>
                </div>
            </div>
        </div>

        <DrawerPost 
            v-if="eventSelected" 
            :event="eventSelected"
            @close="closeDrawer"
            @deletePost="handlerDeletePost"
        />
    </div>
</template>

<script>
import MainNavigation from './components/MainNavigation.vue'
import Phone from "./../postCreator/components/Phone.vue"
import Avatar from '../utils/avatar.vue';
import InstagramInterface from "./components/feed/InstagramInterface.vue"
import ListPosts from"./components/feed/ListPosts.vue"
import PostNotFound from "./components/feed/PostNotFound.vue"
import postMixins from '@/components/mixins/Posts.vue'
import DrawerPost from './components/DrawerPost.vue'
import sectionPostMixins from './mixins/main.js'
import { event } from 'vue-analytics';
import { convertOldDraft, patchDraft } from './utils/draft.js';
import Tooltip from '@/components/dash/tooltip/tooltipInit.vue'

export default {
    
    components: {
        MainNavigation,
        Avatar,
        Phone,
        InstagramInterface,
        ListPosts,
        PostNotFound,
        DrawerPost,
        Tooltip
    },

    mixins: [postMixins, sectionPostMixins],

    props: {
        tabSelected: String
    },

    data() {
        return {
            pageSelected: null,

            plannedItems: [
                // { name: "John 1", id: 0, date: "2025-03-28T15:08:57.701Z", url: "https://picsum.photos/701", status : 'scheduled'},
                // { name: "Joao 2", id: 1, date: "2025-03-27T14:08:57.701Z", url: "https://picsum.photos/702", status : 'scheduled'},
                // { name: "Jean 3", id: 2, date: "2025-03-28T14:08:57.701Z", url: "https://picsum.photos/703", status : 'draft'},
                // { name: "Jonny 4", id: 3, date: "2025-03-28T11:08:57.701Z", url: "https://picsum.photos/704", status : 'draft'}, 
                // { name: "Guisepe 5", id: 4, date: "2025-03-27T14:08:57.701Z", url: "https://picsum.photos/705", status : 'draft'},
              
            ],

            postedItems: [
                // { name: "Hello 6", id: 5, date: "2025-03-22T19:00:57.701Z", url: "https://picsum.photos/706", status : 'posted'},
                // { name: "dism 7", id: 6, date: "2025-03-21T11:08:57.701Z", url: "https://picsum.photos/707", status : 'posted'},
                // { name: "Hello 6", id: 7, date: "2025-03-22T19:00:57.701Z", url: "https://picsum.photos/708", status : 'posted'},
                // { name: "dism 7", id: 8, date: "2025-03-21T11:08:57.701Z", url: "https://picsum.photos/709", status : 'posted'},
                // { name: "Hello 6", id: 9, date: "2025-03-22T19:00:57.701Z", url: "https://picsum.photos/710", status : 'posted'},
                // { name: "dism 7", id: 10, date: "2025-03-21T11:08:57.701Z", url: "https://picsum.photos/711", status : 'posted'},
                // { name: "Hello 6", id: 11, date: "2025-03-22T19:00:57.701Z", url: "https://picsum.photos/712", status : 'posted'},
                // { name: "dism 7", id: 12, date: "2025-03-21T11:08:57.701Z", url: "https://picsum.photos/713", status : 'posted'},
            ],

            pinnedItems: [
                { name: "Hello 6", id: 13, date: "2025-03-22T19:00:57.701Z", url: "https://picsum.photos/714", status : 'posted'},
            ],

            groupedItems: {}, // Objets regroupés par date
            mergedList: [],

            statsProfile: {
                followers_count: 0,
                follows_count: 0,
                media_count: 0,
            },

            configFetchItemPosted: {
                currentDate: null,
                tagsCursor: null,
                isEnd: false,
                isEndTags: false,
                isLoading: false
            },
            eventSelected : null,
        }
    },

    mounted () {
        this.pageSelected = this.pagesSelected[0]
        if (this.pageSelected){
            this.fetchData()
        }
    },
    methods: {
        async fetchData() {
            //recuperation des items posté
            this.postedItems = []
            this.pinnedItems = []
            this.plannedItems = []
            this.syncGroupedItems();

            if (!this.pageSelected) return
            const date = new Date();
            let currentStart = date.toISOString();
            date.setMonth(date.getMonth() + 12);
            let currentEnd = date.toISOString()

            const {body} = await this.postsByPages(
                this.pageSelected.id, 
                1000,
                currentStart,
                currentEnd,
                false,
                false,
                false
            )
           
            for (const post of body.posts) {
            
                const status = post.page && post.page.length ? ['removed', null, 'scheduled', 'posted', 'pending', 'failed', null, 'draft'][post.page[0].status + 1] : 'standby'

                if (['scheduled','draft'].includes(status) && (!post.page[0] || !post.page[0].story) && post.enclosure) {
            
                    const event = await this.buildEvent(post);
                    if (event.type !== 'story') {
                        this.plannedItems.push({
                            ...event,
                            name: post.title, 
                            content: post.title, 
                            id: post.id,
                            date: event.date,
                            url: post.enclosure, 
                            status : status,
                            format_date: new Date(event.date).toLocaleTimeString(this.$i18n.locale || 'fr-FR', {hour: '2-digit', minute: '2-digit'})
                        })
                    }
                }
                
            }

            this.sortItems()
            this.syncGroupedItems();

      
       
            
            try {
                this.statsProfile= {
                    followers_count:0,
                    follows_count:0,
                    media_count:0
                }

                this.configFetchItemPosted= {
                    currentDate: null,
                    tagsCursor: null,
                    isEnd: false,
                    isEndTags: false,
                    isLoading: false
                }

                const {body} = await this.getInstagramPageStatsProfile(this.pageSelected.id)
                
                if (body.success) {
                    this.statsProfile = {
                        followers_count: body.followers_count,
                        follows_count: body.follows_count,
                        media_count: body.media_count,
                    }
                    

                    const currentDate = new Date();
                    currentDate.setDate(1);

                    this.configFetchItemPosted = {
                        currentDate: currentDate,
                        isEnd: false,
                        isLoading: false
                    }

                
                    this.fetchItemPosted()
                    console.log('posts', this.postedItems, currentDate)
                }else{
                    throw new Error("Failed to fetch Instagram stats");
                }
                
            } catch (error) {
                this.configFetchItemPosted.isLoading = false
                this.configFetchItemPosted.isEnd = true
                console.log("Error fetching Instagram stats: ", error);
            }
            console.log('body',body)
        },

        async fetchItemPosted() {
            if (this.configFetchItemPosted.isLoading || this.configFetchItemPosted.isEnd) return
            const pageIdSelected = this.pageSelected.id
            this.configFetchItemPosted.isLoading = true
            const twoYearsAgo = new Date()
            twoYearsAgo.setFullYear(twoYearsAgo.getFullYear() - 2)

            const allNewPosts = []
            const seenIds = new Set(this.postedItems.map(p => p.id))

            // Frontier = oldest timestamp fetched from each stream so far this call.
            // The stream with the more recent (higher) frontier hasn't gone as far back
            // and should be advanced next — this keeps both streams in sync.
            // mediaFrontier starts at Infinity so media is always fetched first, giving
            // collab a real timestamp to compare against before it starts running.
            let mediaFrontier = Infinity
            let collabFrontier = Infinity

            const ownPostsShown = () =>
                this.postedItems.filter(p => !p.collab).length +
                allNewPosts.filter(p => !p.collab).length

            const mediaExhausted = () =>
                this.configFetchItemPosted.currentDate < twoYearsAgo ||
                ownPostsShown() >= this.statsProfile.media_count

            while (
                pageIdSelected === this.pageSelected.id &&
                allNewPosts.length < 9 &&
                !(mediaExhausted() && this.configFetchItemPosted.isEndTags)
            ) {
                // Only start comparing frontiers once media has been fetched at least once.
                // Until then, always advance media so collab has a real anchor timestamp.
                const shouldAdvanceCollab =
                    !this.configFetchItemPosted.isEndTags &&
                    (mediaExhausted() ||
                     (mediaFrontier !== Infinity && collabFrontier >= mediaFrontier))

                if (shouldAdvanceCollab) {
                    // Fetch one page of collaborative_media
                    try {
                        const { body } = await this.getInstagramTagsPage(pageIdSelected, this.configFetchItemPosted.tagsCursor)
                        if (!body || !body.success) {
                            this.configFetchItemPosted.isEndTags = true
                        } else {
                            const freshCollabs = (body.posts || [])
                                .filter(p => !seenIds.has(p.id))
                                .map(p => ({
                                    name: p.caption,
                                    id: p.id,
                                    date: p.timestamp,
                                    url: p.thumbnail_url || p.media_url,
                                    status: 'posted',
                                    collab: true,
                                    type: {CAROUSEL_ALBUM: 'carousel', IMAGE: '', VIDEO: 'reel'}[p.media_type]
                                }))
                            freshCollabs.forEach(p => seenIds.add(p.id))
                            allNewPosts.push(...freshCollabs)
                            this.configFetchItemPosted.tagsCursor = body.nextCursor || null
                            if (!body.nextCursor) this.configFetchItemPosted.isEndTags = true
                            if (body.posts && body.posts.length > 0)
                                collabFrontier = Math.min(...body.posts.map(p => new Date(p.timestamp).getTime()))
                        }
                    } catch (e) {
                        console.error('Error fetching collaborative media: ', e)
                        this.configFetchItemPosted.isEndTags = true
                    }
                } else {
                    // Fetch one month of media
                    const startOfMonth = new Date(this.configFetchItemPosted.currentDate.getFullYear(), this.configFetchItemPosted.currentDate.getMonth(), 1)
                    const endOfMonth = new Date(this.configFetchItemPosted.currentDate.getFullYear(), this.configFetchItemPosted.currentDate.getMonth() + 1, 1)
                    // Default frontier: start of month (handles months with zero own posts)
                    mediaFrontier = startOfMonth.getTime()
                    try {
                        const { body } = await this.getPostsFromRS(pageIdSelected, Math.floor(startOfMonth.getTime() / 1000), Math.floor(endOfMonth.getTime() / 1000))
                        if (body.success && body.posts && body.posts.data.length > 0) {
                            const mapped = body.posts.data.map(post => ({
                                name: post.caption,
                                id: post.id,
                                date: post.timestamp,
                                url: post.full_picture,
                                status: 'posted',
                                type: {CAROUSEL_ALBUM: 'carousel', IMAGE: '', VIDEO: 'reel'}[post.media_type]
                            }))
                            const fresh = mapped.filter(p => !seenIds.has(p.id))
                            fresh.forEach(p => seenIds.add(p.id))
                            allNewPosts.push(...fresh)
                            mediaFrontier = Math.min(...mapped.map(p => new Date(p.date).getTime()))
                        } else if (!body.success) {
                            break
                        }
                    } catch (e) {
                        console.error('Error fetching media: ', e)
                        break
                    }
                    this.configFetchItemPosted.currentDate.setMonth(this.configFetchItemPosted.currentDate.getMonth() - 1)
                }
            }

            if (pageIdSelected !== this.pageSelected.id) return

            if (mediaExhausted() && this.configFetchItemPosted.isEndTags) {
                this.configFetchItemPosted.isEnd = true
            }

            this.postedItems = [...this.postedItems, ...allNewPosts]
                .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
            this.configFetchItemPosted.isLoading = false
        },

        async refreshInstagramData() {
            this.configFetchItemPosted= {
                currentDate: null,
                isEnd: false,
                isLoading: false
            }
            this.postedItems = []

            const {body} = await this.getInstagramPageStatsProfile(this.pageSelected.id)
            
            if (body.success) {
                this.statsProfile = {
                    followers_count: body.followers_count,
                    follows_count: body.follows_count,
                    media_count: body.media_count,
                }
                

                const currentDate = new Date();
                currentDate.setDate(1);

                this.configFetchItemPosted = {
                    currentDate: currentDate,
                    isEnd: false,
                    isLoading: false
                }

                this.fetchItemPosted()
                console.log('posts', this.postedItems, currentDate)
            }
        },

        selectPage(page) {
            this.pageSelected = page
            this.fetchData()
        },

        async changeDate({postId, newDate, itemsSort, refreshGroupedItems = true}) {
            console.log("changeDate", {postId, newDate, itemsSort, refreshGroupedItems})
            if (itemsSort) {
                this.plannedItems = itemsSort
            }else{
                const indexPost = this.plannedItems.findIndex(item => item.id == postId)
                if (indexPost) {
                    this.plannedItems[indexPost].date = newDate
                    this.sortItems()
                }
            }

            if (refreshGroupedItems) {
                this.syncGroupedItems()
            }

            const event = this.plannedItems.find(item => item.id == postId)
            if (event) {
                this.$set(event, 'format_date', new Date(event.date).toLocaleTimeString(this.$i18n.locale || 'fr-FR', {hour: '2-digit', minute: '2-digit'}))
                
                if (event.originalPost) {
                    const dateInstance = new Date(newDate)
                    const {body} = await this.updatePostScheduledDate(event.originalPost, {
                        date: newDate,
                        hour: dateInstance.getHours(), 
                        minute: dateInstance.getMinutes(), 
                        scheduledDate: newDate,
                    }, false, false)
                }
             
            }
        },

        sortItems() {
            this.plannedItems.sort((a, b) => new Date(b.date) - new Date(a.date));
        },

        syncGroupedItems(sortItems = false) {
            if (sortItems) this.sortItems()
            this.groupedItems = {}
            this.plannedItems.forEach(item => {
                const date = item.date.split('T')[0]
                if (!this.groupedItems[date]) this.groupedItems[date] = []
                this.groupedItems[date].push(item)
            });

            //trier chaque group par date
            // Object.keys(this.groupedItems).forEach(date => {
            //     this.groupedItems[date].sort((a, b) => new Date(a.date) - new Date(b.date));
            // });
           
        },

        syncMergeList() {

        },

         async handleEventClick(event) {
          
            if (event.draft && !event.draft.saveAllFormData) {

                const pages =  event.originalPost.page && event.originalPost.page[0].posts_multipages ? 
                    event.originalPost.page[0].posts_multipages.map(({page}) => page) : 
                    [event.page.id]

                const draft = patchDraft(await convertOldDraft(JSON.parse(JSON.stringify(event.draft)), pages))
                
                event.draft = draft                
            }
            this.eventSelected = event
        },
        
        closeDrawer() {
            this.eventSelected = null
        },
    },

    watch: {
        pagesSelected: {
            immediate: true,
            handler(newValue, oldValue) {
                if (!newValue.length) {
                    this.$emit('changeTab','planner')
                }
            }
        }
    },

    computed: {

        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },
        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]).filter(page => page.network == 'instagram');
        }
    }
} 
</script>